export interface CallerHandledAuthFailureOptions {
  callerHandlesAuthFailure?: boolean
  skipBusinessContextBarrier?: boolean
}

export function getCallerHandledAuthFailureConfig(
  options: CallerHandledAuthFailureOptions = {},
) {
  return {
    ...(options.callerHandlesAuthFailure
      ? {
          skipAuthExpiredPrompt: true,
          skipGlobalErrorToast: true,
        }
      : {}),
    ...(options.skipBusinessContextBarrier ? { skipBusinessContextBarrier: true } : {}),
  }
}
